/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="filters.module.ts" />

module Meevo.Components.Filters {

    import TimeFormatEnum = Meevo.Model.TimeFormatEnum;

    function convertToDate(input: any): Date
    {
        if (typeof input === 'string') {
            input = new Date(input);
        }
        else if (input.hasOwnProperty('_isAMomentObject ')) {
            input = input.toDate();
        }

        return input;
    }

    /**
     * meevoDateTimeFilter will format date/time value
     * @param $filter
     */
    export function meevoDateTimeFilter($filter: any): any {
        const filter = (input: any, showSeconds?: boolean) => {
            if (!input) {
                return '';
            }

            input = convertToDate(input);

            var dateFilter = $filter('date');
            var output = showSeconds
                ? dateFilter(input, 'EEE ') + dateFilter(input, 'shortDate') + ' ' + dateFilter(input, 'mediumTime')
                : dateFilter(input, 'EEE ') + dateFilter(input, 'shortDate') + ' ' + dateFilter(input, 'shortTime');
            return output.trim();
        };
        return filter;
    }

    meevoDateTimeFilter.$inject = ['$filter'];

    angular.module('meevo.components.filters')
        .filter('meevoDateTimeFilter', meevoDateTimeFilter);


    /**
     * meevoDateTimeWithSecondsFilter will format date/time with seconds value for appropriate locale setting from moment.
     * @param $filter
     */
    export function meevoDateTimeWithSecondsFilter($filter: any): any {
        const filter = (input: any) => {
            if (!input) {
                return '';
            }

            input = convertToDate(input);

            var dateFilter = $filter('date');
            var output = dateFilter(input, 'EEE ') + dateFilter(input, 'shortDate') + ' ' + dateFilter(input, 'mediumTime');
            return output.trim();
        };
        return filter;
    }

    meevoDateTimeWithSecondsFilter.$inject = ['$filter'];

    angular.module('meevo.components.filters')
        .filter('meevoDateTimeWithSecondsFilter', meevoDateTimeWithSecondsFilter);


    /**
     * meevoTimeFilter will format time value for appropriate locale setting from moment.
     * showSeconds param - if true use format with seconds, otherwise use regular time format
     * @param $filter
     */
    export function meevoTimeFilter($filter: any): any {
        const filter = (input: any, showSeconds?: boolean) => {
            if (!input) {
                return '';
            }
            var dateFilter = $filter('date');
            var output = showSeconds ? dateFilter(input, 'mediumTime') : dateFilter(input, 'shortTime');
            return output.trim();
        };
        return filter;
    }

    meevoTimeFilter.$inject = ['$filter'];

    angular.module('meevo.components.filters')
        .filter('meevoTimeFilter', meevoTimeFilter);


    /**
     * meevoTimeWithSecondsFilter will format time with seconds value for appropriate locale setting from moment.
     * @param $filter
     */
    export function meevoTimeWithSecondsFilter($filter: any): any {
        const filter = (input: any) => {
            if (!input) {
                return '';
            }
            var dateFilter = $filter('date');
            var output = dateFilter(input, 'mediumTime');
            return output.trim();
        };
        return filter;
    }

    meevoTimeWithSecondsFilter.$inject = ['$filter'];

    angular.module('meevo.components.filters')
        .filter('meevoTimeWithSecondsFilter', meevoTimeWithSecondsFilter);


    /**
     * meevoDateFilter will replace date format string for appropriate locale setting from moment.
     * hideYear param - if true will use format without year, otherwise use regular date format
     * @param $filter
     */
    export function meevoDateFilter($filter: any): any {
        const filter = (input: any, hideYear?: boolean) => {
            if (!input) {
                return '';
            }
            input = convertToDate(input);
            var dateFilter = $filter('date');
            var output = hideYear ? dateFilter(input, 'EEE ') + dateFilter(input, 'shortDateWithoutYear') : dateFilter(input, 'EEE ') + dateFilter(input, 'shortDate');
            return output.trim();
        };
        return filter;
    }

    meevoDateFilter.$inject = ['$filter'];

    angular.module('meevo.components.filters')
        .filter('meevoDateFilter', meevoDateFilter);





    /**
     * meevoDateWithoutYearFilter will use format without year for appropriate locale setting from moment.
     * @param $filter
     */
    export function meevoDateWithoutYearFilter($filter: any): any {
        const filter = (input: any) => {
            if (!input) {
                return '';
            }
            var dateFilter = $filter('date');
            var output = dateFilter(input, 'EEE ') + dateFilter(input, 'shortDateWithoutYear');
            return output.trim();
        };
        return filter;
    }

    meevoDateWithoutYearFilter.$inject = ['$filter'];

    angular.module('meevo.components.filters')
        .filter('meevoDateWithoutYearFilter', meevoDateWithoutYearFilter);


    /**
     * meevodate
     * Only Pre Defined Date/Time Formats Will Honor Locale Date/Time Formats
     * 
     * @param $filter
     */
    export function meevodate($filter) {
        return (input, format) => {
            if (!input || !format) return;
            var momentFormat = moment.localeData().longDateFormat('L').split('/YYYY')
            var localeFormat = format.replace(/(M{1,2}\/d{1,2})/i, moment(input).format(momentFormat[0]))
            var date = $filter('date')(input, localeFormat)

            //Revert Back Changese In Changeset 66288
            //var momentFormat = moment.localeData().longDateFormat('L');
            //var localeFormat = format.replace(/(M{1,2}\/d{1,2}\/y{2,4})/i, moment(input).format(momentFormat));
            //var date = $filter('date')(input, localeFormat);
            return date;
        };
    }

    meevodate.$inject = ['$filter'];

    angular.module('meevo.components.filters')
        .filter('meevodate', meevodate);

    /**
     * meevotime
     * @param $filter
     * @param appSettings
     */
    export function meevotime($filter, appSettings: Meevo.Components.Common.IAppSettings) {
        return (input) => {
            if (!input) return;
            let is24: boolean = appSettings.APP_TIME_FORMAT === TimeFormatEnum.TimeFormat24;
            let hoursFormat: string = is24 ? 'HH' : 'hh';
            let format = `${hoursFormat}:mm ${is24 ? '' : 'a'}`;

            if (typeof input === 'string') {
                return moment(input, 'HH:mm:ss').format(format);
            } else if (input instanceof Date) {
                return moment(input).format(format);
            }
        };
    }

    meevotime.$inject = ['$filter', 'meevo.AppSettings'];

    angular.module('meevo.components.filters')
        .filter('meevotime', meevotime);


    export function meevoTimeDisplay($filter) {
        return (input) => {
            if (isNaN(input)) return;

            const hours = Math.floor(input / 60);
            const minutes = input % 60
            
            let time = !!hours ? `${hours}h ` : '';
            time += !!minutes ? `${minutes}m` : ''


            return time || '0m';

        };
    }

    meevoTimeDisplay.$inject = ['$filter'];

    angular.module('meevo.components.filters')
        .filter('meevoTimeDisplay', meevoTimeDisplay);

}